import { t } from 'ttag';

// eslint-disable-next-line import/prefer-default-export
export const fixedFields = () => [
  { id: 'firstName', label: t`First Name`, value: ({ person }) => person.firstName },
  { id: 'lastName', label: t`Last Name`, value: ({ person }) => person.lastName },
  { id: 'company', label: t`Company`, value: ({ person }) => person.companyName },
  { id: 'title', label: t`Title/Position`, value: ({ person }) => person.title },
];
